// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3768":"945faee8","6235":"57c22a2a"}[chunkId] + ".chunk.css";
};